//Import required libraries
import React from 'react';

const RadioSelect = props => {
    
    let { name, options, userInput, setUserInput } = props

    const handleChange = event => {
        setUserInput({
            ...userInput,
            [name]: event.target.value,
        })
    }

    return (
        <div>
        {
            options.map((obj, index) => (
                <React.Fragment key={index}>
                    <input type="radio" 
                            name={name}
                            value={obj.value}
                            checked={userInput[name] === obj.value}
                            onChange={handleChange}></input>
                    <label htmlFor={obj.value}>{obj.label}</label>
                </React.Fragment>
            ))
        }
        </div>
    );
}
export default RadioSelect